import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SeoMetaManager } from '@hypedirector/shared-ui';
import { LandingPage } from './components/LandingPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { VisionPage } from './pages/VisionPage';
import { MomentSearchPage } from './pages/MomentSearchPage';

const PUBLIC_SEO_PATHS = ['/', '/vision', '/search', '/contact', '/privacy', '/terms'];

export const App: React.FC = () => {
  return (
    <Router>
      <SeoMetaManager publicPaths={PUBLIC_SEO_PATHS} />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/search" element={<MomentSearchPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </Router>
  );
};

